import { apiGet, apiPost, apiPut, apiDelete } from './api';
import type {
  Vocabulary,
  CreateVocabularyDTO,
  UpdateVocabularyDTO,
  VocabularyQueryParams,
  PaginatedVocabularyResponse,
} from '../types/vocabulary.types';

export const vocabularyService = {
  /**
   * Fetch paginated vocabulary list with optional search and sorting.
   */
  async getVocabularies(params?: VocabularyQueryParams): Promise<PaginatedVocabularyResponse> {
    return apiGet<PaginatedVocabularyResponse>('/vocabulary', params as Record<string, unknown>);
  },

  /**
   * Fetch a single vocabulary item by ID.
   */
  async getVocabulary(id: string): Promise<Vocabulary> {
    return apiGet<Vocabulary>(`/vocabulary/${id}`);
  },

  /**
   * Create a new vocabulary item.
   */
  async createVocabulary(data: CreateVocabularyDTO): Promise<Vocabulary> {
    return apiPost<Vocabulary, CreateVocabularyDTO>('/vocabulary', data);
  },

  /**
   * Update an existing vocabulary item.
   */
  async updateVocabulary(id: string, data: UpdateVocabularyDTO): Promise<Vocabulary> {
    return apiPut<Vocabulary, UpdateVocabularyDTO>(`/vocabulary/${id}`, data);
  },

  /**
   * Delete a vocabulary item.
   */
  async deleteVocabulary(id: string): Promise<{ id: string }> {
    return apiDelete<{ id: string }>(`/vocabulary/${id}`);
  },
};
